import { get } from "../Service/ApiConfig";
import { DashboardEndPoints } from "../Service/Endpoints/ApiEndPoints";


export const GetUserCount = async () => {
  const response = await get(DashboardEndPoints.getUsers);
  return response;
};

export const GetDoctorSpecialization = async (id) => {
  const response = await get(DashboardEndPoints.getSpecialization(id));
  return response;
};

export const GetUserProfileInformation = async (email) => {
  const response = await get(DashboardEndPoints.getUserInformation(email));
  return response;
};
